import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/fx-rates");

export const Route = createFileRoute("/fx-rates")({
  head: () => ({
    meta: [
      { title: "Exchange rates — LevelLoad" },
      { name: "description", content: "Exchange rates — LevelLoad transport planning." },
      { property: "og:title", content: "Exchange rates — LevelLoad" },
      { property: "og:description", content: "Exchange rates — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
